// «Где лежит материал» — предикаты Библиотеки для локального SQLite.
//
// Серверные оригиналы — `modules/library/_internal/library-filters.ts`. Клиенту
// они нужны потому, что серверные счётчики сегмент-контрола («Все / Не в курсе
// / Без папки») не знают о материалах, удалённых локально и ещё не уехавших в
// upload-очереди: их надо вычесть на месте (см. `use-pending-deletions.ts`).
//
// Копия предиката на клиенте — цена офлайна, но копия должна быть ОДНА: до
// 2026-08-21 условие «не в курсе» было выписано в `library.manifest.ts` для
// бейджа навигации и больше нигде, поэтому счётчик в сайдбаре и счётчик над
// списком считались разными способами.
//
// РАСХОЖДЕНИЕ С СЕРВЕРОМ, о котором надо знать. Сервер считает составом курса
// набор с `kind='course_source'` ИЛИ тот, на который ссылается живой
// `study_plans.generated_from_set_id` (легаси до миграции 0083, где `kind` не
// бэкфиллили). Здесь проверяется только `kind` — как и раньше в манифесте.
// Последствие ограничено и безобидно: у пользователя с легаси-набором поправка
// к счётчику «не в курсе» может отличаться на единицу на те секунды, пока
// удаление не доехало до сервера. Расширять до второго условия можно —
// `study_plans` синкается, — но лишний подзапрос в реактивном watch'е того не
// стоит.

import { COURSE_SOURCE_SET_KIND } from "@studyhub/shared/learning";

/**
 * Материал не входит ни в один состав курса — ни напрямую, ни через папку,
 * добавленную в состав (разворачивание на один уровень, как в резолвере).
 *
 * @param alias алиас таблицы `materials` в запросе
 */
export function materialNotInAnyCourse(alias: string): string {
	return `NOT EXISTS (
		SELECT 1 FROM set_items si
		JOIN folders ms ON ms.id = si.folder_id
		WHERE ms.kind = '${COURSE_SOURCE_SET_KIND}'
		  AND ms.deleted_at IS NULL
		  AND (
		    (si.item_type = 'material' AND si.item_id = ${alias}.id)
		    OR (si.item_type = 'folder' AND EXISTS (
		      SELECT 1 FROM set_items fi
		      WHERE fi.folder_id = si.item_id
		        AND fi.item_type = 'material'
		        AND fi.item_id = ${alias}.id
		    ))
		  )
	)`;
}

/**
 * Материал не лежит ни в одной живой пользовательской папке.
 *
 * @param alias алиас таблицы `materials` в запросе
 */
export function materialNotInAnyFolder(alias: string): string {
	return `NOT EXISTS (
		SELECT 1 FROM set_items si
		JOIN folders f ON f.id = si.folder_id
		WHERE si.item_type = 'material'
		  AND si.item_id = ${alias}.id
		  AND f.kind <> '${COURSE_SOURCE_SET_KIND}'
		  AND f.deleted_at IS NULL
	)`;
}
